import { observer } from "mobx-react-lite"

import { Search } from "@/components/search"
import { Switch } from "@/components/switch"
import { useScaleApplication } from "@/domains/application/use-scale-application"
import { SwitchDetailedMode } from "@/domains/common/components/switches/switch-detailed-mode"
import { SwitchMyPositions } from "@/domains/common/components/switches/switch-my-positions"
import { CompactIcon } from "@/domains/icons"
import { useGovernanceToken } from "@/hooks/use-governance-token"
import { useNativeToken } from "@/hooks/use-native-token"

export const MobileView = observer(() => {
  const scaleApp = useScaleApplication()
  const nativeToken = useNativeToken()
  const governanceToken = useGovernanceToken()

  return (
    <div className="bg-p400 border-p400-light flex w-full flex-col gap-4 rounded-lg border px-3 py-4">
      <Search
        className="text-t200"
        placeholder={`${governanceToken.name}, ${nativeToken.name}, BTC, ETH, 0x...`}
        value={scaleApp.Pages.ClFarms.search}
        onChange={(e) => scaleApp.Pages.ClFarms.setSearchFromUi(e.target.value)}
      />

      <div className="flex flex-wrap items-center justify-start gap-4">
        <SwitchMyPositions
          checked={scaleApp.Pages.ClFarms.stakedOnly}
          onCheckedChange={(value) => scaleApp.Pages.ClFarms.setStakedOnlyFromUi(value)}
        />
        <SwitchDetailedMode
          checked={scaleApp.Pages.ClFarms.isDetailed}
          onCheckedChange={(value) => scaleApp.Pages.ClFarms.setIsDetailedFromUi(value)}
        />
      </div>
    </div>
  )
})
